import { ChevronDown, Menu, X } from 'lucide-react'
import { useState } from 'react'
import { Logo } from '../common/Logo'
import { trackEvent } from '../../utils/analytics'
import { navTargets } from '../../utils/landingContent'
import type { LandingCopy, Language } from '../../models/LandingPage'

type HeaderProps = {
  copy: LandingCopy
  language: Language
  onLanguageChange: (language: Language) => void
}

export function Header({ copy, language, onLanguageChange }: HeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false)
  const nextLanguage = language === 'en' ? 'it' : 'en'

  function handleLanguageChange() {
    onLanguageChange(nextLanguage)
    trackEvent('language_changed', { language: nextLanguage })
  }

  function handleNavClick(target: string) {
    setMenuOpen(false)
    if (target === '/#hardware') {
      trackEvent('supported_hardware_clicked', { source: 'header_nav' })
    }
  }

  return <header className="site-header"><div className="container nav-wrap"><Logo href="/"/><nav className={menuOpen?'open':''} aria-label="Primary">{copy.nav.map((n,i)=><a key={n} href={navTargets[i]} onClick={()=>handleNavClick(navTargets[i])}>{n}</a>)}</nav><div className="nav-actions"><button className="lang" type="button" onClick={handleLanguageChange} aria-label={`Switch language to ${nextLanguage.toUpperCase()}`}>{language.toUpperCase()} <ChevronDown size={13}/></button><a className="button small" href="/#beta">{copy.join}</a><button className="menu" type="button" onClick={()=>setMenuOpen(!menuOpen)} aria-label="Menu" aria-expanded={menuOpen}>{menuOpen?<X/>:<Menu/>}</button></div></div></header>
}
